import React, {useState,useContext, useEffect} from 'react';
              
import { CheckBox, ExpandCollapse,EmailTooltip,ActionLink } from '../../atoms';
import { DashService, InsightsService } from '../../../services';
import { Button, ModalWindow } from '../../atoms';
import {  UserContext, DashboardContext } from '../../../context';
import { default as t } from '../../../utils/i18n';
import { DatePicker } from 'rsuite';
import {isAfter, isBefore} from 'date-fns';
import InputGroup from 'rsuite/InputGroup';
import './report-wrapper.scss';

const ReportWrapper = (props) => {
    
        const { user } = useContext(UserContext);
        const { dashData, setDashData } = useContext(DashboardContext);
        const userAccessToken = user?.tokens?.accessToken?.jwtToken;
        const username = user?.username;

        const [countryList, setCountryList] = useState([]);
        const [countries, setCountries] = useState([]);
        const [industries, setIndustries] = useState([]);
        const [kpis, setKpis] = useState([]);
        const [advertisers, setAdvertisers] = useState([]);
        const [showFilterErrorModal, setShowFilterErrorModal] = useState(false);
        const [showFilterSuccessModal, setShowFilterSuccessModal] = useState(false);
        const [showFilterExistingReportModal, setShowFilterExistingReportModal] = useState(false);
        const [showDataInsufficientModal, setShowDataInsufficientModal] = useState(false);
        const [showDataInsufficientCode, setShowDataInsufficientCode] = useState([]);
        const [forcedReportData, setForcedReportData] = useState([]);
       
        const [newReport, setNewReport] = useState(false);
        const [countriesSelected, setCountriesSelected] = useState([]);
        const [industriesSelected, setIndustriesSelected] = useState([]);
        const [kpisSelected, setKpisSelected] = useState([]);
        const [advertisersSelected, setAdvertisersSelected] = useState([]);
        const [reportId, setReportId] = useState('');
        const [createDate, setCreateDate] = useState('');
        const [checkedArr, setcheckedArr] = useState([]);
        const [isForce, setIsForce] = useState(false);
        const blsKPIName = 'Brand Lift';
        const [isBLSKpi, setIsBLSKpi] = useState(false);
        const [startDate, setStartDate] = React.useState(new Date());
        const [endDate, setEndDate] = React.useState(new Date());
        /* get Counttry, kpi, Industry, Advertisers list */
        async function getCountryList() {
        try {
            const countryListResponse = await DashService.countryList(userAccessToken, username);
            // //console.log('countryListResponse::', countryListResponse.data);
            const countryList = countryListResponse.data?.data;
            const checkedList = [...countryList];
            setCountryList(checkedList);
            const countryNames = checkedList.map(item => item.name);
            setCountries(countryNames);
            setDashData(prevDashData => ({
              ...prevDashData,
              countryList: [...countryList],
            }));
        } catch (error) {
            const dataCode = error?.data?.data?.code;
            if (dataCode) {
                //console.log(dataCode);
            }
            }
        }
        
        async function getKpiList() {
             try {
                const kpiListResponse = await DashService.kpiListEfficiency(userAccessToken, username);
                const kpiList = kpiListResponse.data?.data;
                const checkedList = [...kpiList];
                setKpis(checkedList);
                setDashData(prevDashData => ({
                    ...prevDashData,
                    kpiList: [...kpiList],
                  }));
             } catch (error) {
                const dataCode = error?.data?.data?.code;
                if (dataCode) {
                    //console.log(dataCode);
                }
            }
        }
       
        async function getIndustryList() {
            try {
                const industryListResponse = await DashService.industryList(userAccessToken, username);
                // //console.log('industryListListResponse::', industryListResponse.data);
                const industryList = industryListResponse.data?.data;
                const checkedList = [...industryList];
                const industryNames = checkedList.map(item => item.name);
                setIndustries(industryNames);
            } catch (error) {
                const dataCode = error?.data?.data?.code;
                if (dataCode) {
                    //console.log(dataCode);
                }
            }
        }

        async function getAdvertiserList() {
            try {
                const advertiserListResponse = await DashService.advertiserList(userAccessToken, username);
                // //console.log('advertiserListResponse:', advertiserListResponse.data);
                const advertiserList = advertiserListResponse.data?.data;
                const checkedList = [...advertiserList];
                setAdvertisers(checkedList);
            } catch (error) {
                const dataCode = error?.data?.data?.code;
                if (dataCode) {
                    //console.log(dataCode);
                }
            }
        }
        useEffect(() => {
            getCountryList();
            getKpiList();
            getIndustryList();
            getAdvertiserList();
            document.body.style.overflow = "auto";
        }, [])

        /* Create Report code */
        const handleOnCloseErrorModal = () => {
            setShowFilterErrorModal(false);
          };
        const handleOnCloseSuccessModal  = () => {
            setShowFilterSuccessModal(false);
             props.updateTableListing(true);
             resetFields();
        }
        const handleOnCloseExistingReportModal  = () => {
            setShowFilterExistingReportModal(false);
             props.updateTableListing(true);
             resetFields();
        }
        const handleOnCloseInsuffiecientDataModal = () => {
            setShowDataInsufficientModal(false);
        }
        const  handleGoToReport = () => {
            handleOnCloseExistingReportModal();
            props.updateTableListing(true);
            resetFields();
        }
        const newReportHandler = (e) => {
            e.preventDefault();
            handleCreateReport(true);
            handleOnCloseExistingReportModal();    
        }

        const checkboxStatus = (event) => {
             event.target.checked ? setNewReport(true) : setNewReport(false);  
            // console.log('checkboxStatus '+newReport);
        }
        const handleCreateReportbtnClick = (e) => {
          return newReport ? handleCreateReport(true) : handleCreateReport(false);
            // resetFields();
        }
        const resetFields = () => {
          // console.log('resetFields');
          setNewReport(false);
           setKpisSelected([]);
          if(document.querySelector('#start-date ~ .rs-btn-close')) { document.querySelector('#start-date ~ .rs-btn-close').click(); }
          if(document.querySelector('#end-date ~ .rs-btn-close')) { document.querySelector('#end-date ~ .rs-btn-close').click(); }

          // No preference selected by default
          const country_nopref =  document.getElementById(`country-nopreference` );
          const industry_nopref =  document.getElementById(`industry-nopreference` );
          //const advertiser_nopref =  document.getElementById(`advertiser-nopreference` );
          let countryItem =  {
              id:  country_nopref.id,
              value: country_nopref.name+'-'+country_nopref.value  
            }
          // let advertiserItem =  {
          //   id:  advertiser_nopref.id,
          //   value: advertiser_nopref.name+'-'+advertiser_nopref.value  
          // }
          let industryItem =  {
            id:  industry_nopref.id,
            value: industry_nopref.name+'-'+industry_nopref.value  
          }
          let checkedList1 = [], checkedList2 = [], checkedList3 = [];
          checkedList1.push(countryItem);
          checkedList2.push(industryItem);
          //checkedList3.push(advertiserItem);
          setCountriesSelected(checkedList1);
         setIndustriesSelected(checkedList2);
          setAdvertisersSelected(checkedList3);
           let checkedItems = [];
          checkedItems.push(country_nopref.id);
          //checkedItems.push(advertiser_nopref.id);
          checkedItems.push(industry_nopref.id);
           setcheckedArr(checkedItems);
        }
        
        const handleCreateReport = async (type)  => {
          //  e.preventDefault();
            try {
                let requestReportResponse;
                const country = countriesSelected.map((i)=> (i.value).split('-').length > 1 ? (i.value).split('-')[1] : i.value );
                const country_codes = countryList.filter(c => country.includes(c.name));
                const selectedCountries = country_codes.map(i => i.country_code);
                const industry = industriesSelected.map((i)=>  (i.value).split('-').length > 1 ? (i.value).split('-')[1] : i.value );
                const advertiser = advertisersSelected.map((i)=> (i.value).split('-').length > 1 ? (i.value).split('-')[1] : i.value ); 
                const kpi = kpisSelected.map((i)=> (i.value).split(':').length > 1 ? (i.value).split(':')[0] : i.value );
                const fromdate = document.getElementById('start-date').value.split('-');
                const startDate = fromdate[2]+'-'+fromdate[1]+'-'+fromdate[0]
                const todate = document.getElementById('end-date').value.split('-');
                const endDate = todate[2]+'-'+todate[1]+'-'+todate[0];
                
                const data = {"from_date":startDate, "to_date":endDate, "kpi":kpi.toString() } ;
                if(country[0] !== 'no_preference')  data.country = selectedCountries;
                if(industry[0] !== 'no_preference') data.industry = industry;
                if(advertiser[0] !== 'no_preference') data.advertiser = advertiser;   
                if(country.length && industry.length && kpi.length && advertiser.length && fromdate.length >1 && todate.length >1) {
                  setForcedReportData(data);
                  setIsForce(type);
                  if(type) {  // to show existing report
                    requestReportResponse = await InsightsService.requestNewReport(userAccessToken, username, data, isBLSKpi);
                    } else {   // to create new report
                      requestReportResponse = await InsightsService.requestReport(userAccessToken, username, data, isBLSKpi);
                    } 
                    setTimeout(() => {
                        const code = requestReportResponse.data.data.code;
                        setShowDataInsufficientCode(requestReportResponse.data.data);
                        setReportId(requestReportResponse.data.data.reportId);
                        const createDate = new Date( (requestReportResponse.data.data.createdAt)*1000 );
                       // console.log('createDate :'+createDate.toLocaleString());
                        let day = ("0" + createDate.getDate()).slice(-2);
                        let month = ("0" + (createDate.getMonth() + 1)).slice(-2);
                        let year = createDate.getFullYear();
                        let formatDate = day+'-'+month+'-'+year;

                        setCreateDate(formatDate);

                        code === 'DB_DATA_INSUFFICENT' ? setShowDataInsufficientModal(true) 
                        :  code?.split('_')[1] === 'ERF' ? setShowFilterExistingReportModal(true) :  setShowFilterSuccessModal(true);
                      }, 200);
                      
                }
                else {
                    setShowFilterErrorModal(true);
                }  
            } catch (error) {
                const dataCode = error?.data?.data?.code;
                console.log(dataCode);
              }
        };
      
       const mapObj = {
         warning_threshold: showDataInsufficientCode?.threshold,
         actual_records: showDataInsufficientCode?.dataVolume,
       };

       const replaceAll = (str, mapObj) => {
         var re = new RegExp(Object.keys(mapObj).join('|'), 'gi');
         return str.replace(re, function (matched) {
           return mapObj[matched.toLowerCase()];
         });
       };

       const triggerConfirmAction = async () => {
         getForceReport(forcedReportData);
         setShowDataInsufficientModal(false);
       };
       
       async function getForceReport(data) {
        let requestReportResponse;
         try {
          if(isForce){
             requestReportResponse = await InsightsService.requestNewForceReport(
              userAccessToken,
              username,
              data,
            );
          }else{
             requestReportResponse = await InsightsService.requestForceReport(
              userAccessToken,
              username,
              data,
            );
          }

           setTimeout(() => {
             const code = requestReportResponse.data.data.code;
             setReportId(requestReportResponse.data.data.reportId);
             const createDate = new Date(requestReportResponse.data.data.createdAt * 1000);
             // console.log('createDate :'+createDate.toLocaleString());
             let day = ('0' + createDate.getDate()).slice(-2);
             let month = ('0' + (createDate.getMonth() + 1)).slice(-2);
             let year = createDate.getFullYear();
             let formatDate = day + '-' + month + '-' + year;

             setCreateDate(formatDate);
             code === 'DB_DATA_INSUFFICENT'
               ? setShowDataInsufficientModal(true)
               : code?.split('_')[1] === 'ERF'
               ? setShowFilterExistingReportModal(true)
               : setShowFilterSuccessModal(true);
           });
         } catch (error) {
           const dataCode = error?.data?.data?.code;
           if (dataCode) {
             //console.log(dataCode);
           }
         }
       }

        
        let today = new Date();
        let currentDay = today.getDate();
        let currentMonth = today.getMonth();
        let currentYear = today.getFullYear() - 3; 

        useEffect(() => {
        if (
          kpisSelected?.length > 0 &&
          kpis.find(kpi => kpi.sys_id === kpisSelected[0]?.value.split(':')[0])?.KPI_subcategory ===
            blsKPIName
        ) {
          setIsBLSKpi(true);
          setStartDate(new Date(currentYear, currentMonth, currentDay));
          setEndDate(new Date());
        } else {
          setIsBLSKpi(false);
          setStartDate('');
          setEndDate('');
        }
      },[kpisSelected])
    return (
      <div className="report-options">
        {isBLSKpi && (
          <div className="bls-rectangle">
            <div className="title">
            Brand Lift
              <p>
              <i className="eva eva-alert-circle-outline"></i>
                Please be aware that the current dataset for Brand Lift Studies (BLS) is limited. As
                a result, the insights generated from BLS KPIs may not be as robust as those from
                other metrics at this time. We recommend using BLS insights primarily for
                observational purposes rather than as a basis for critical campaign planning
                decisions. It is also advised to retain the pre-selected options in other data
                selection categories. This will ensure the inclusion of a broader dataset, enhancing
                the overall reliability of the insights provided. We are actively working on
                expanding the BLS dataset for more detailed and reliable insights in the future.
                Your understanding is appreciated.
              </p>
            </div>
          </div>
        )}
        <div className="report-category kpi">
          <ExpandCollapse
            heading={t('create.report.kpi.heading')}
            placeholder={t('create.report.kpi.placeholder')}
            tooltip={t('report.tooltip.kpi')}
            displayText={t('create.report.kpi.text')}
            options={kpis}
            list={kpisSelected}
            setList={setKpisSelected}
            classname="kpis"
          />
        </div>
        <div className="report-category">
          <CheckBox
            heading={t('Country')}
            topHeader= {t('create.report.country.heading')}
            placeholder={t('create.report.country.placeholder')}
            tooltip={t('report.tooltip.country')}
            options={countries}
            list={countriesSelected}
            setList={setCountriesSelected}
            classname="country"
            selectedItem={checkedArr}
          />
        </div>
        <div className="report-category">
          <CheckBox
            heading={t('Industry')}
            topHeader={t('create.report.industry.heading')}
            placeholder={t('create.report.industry.placeholder')}
            tooltip={t('report.tooltip.industry')}
            options={industries}
            list={industriesSelected}
            setList={setIndustriesSelected}
            classname="industry"
            selectedItem={checkedArr}
          />
        </div>
        <div className="report-category advertisers">
          <CheckBox
            heading={t('Advertiser')}
            topHeader={t('create.report.advertiser.heading')}
            placeholder={t('create.report.advertiser.placeholder')}
            tooltip={t('report.tooltip.advertiser')}
            options={advertisers}
            list={advertisersSelected}
            setList={setAdvertisersSelected}
            classname="advertiser"
            selectedItem={checkedArr}
            isBLSKpi={isBLSKpi}
          />
        </div>
        <div className="report-category daterange">
          <div className="daterange-wrapper">
            <div className="top-section">
              <div className="section-header">
                <h3 className="c-text-heading-3">{t('create.report.date.heading')}</h3>
                <div className="tooltip">
                  <EmailTooltip id="daterange" emailToolTip={t('report.tooltip.daterange')} />
                </div>
              </div>
              {/* <p className="display-text">{t('create.report.date.text')}</p> */}
            </div>
            <div className="bottom-section">
              <InputGroup>
                <DatePicker
                  id="start-date"
                  format="dd-MM-yyyy"
                  disabledDate={date =>
                    isBefore(date, new Date(currentYear, currentMonth, currentDay))
                  }
                  appearance="subtle"
                  placeholder={t('report.wrapper.start.date')}
                  oneTap
                  value={startDate}
                  onChange={setStartDate}
                />
                <InputGroup.Addon>to</InputGroup.Addon>
                <DatePicker
                  id="end-date"
                  format="dd-MM-yyyy"
                  disabledDate={date => isAfter(date, new Date())}
                  appearance="subtle"
                  placeholder={t('report.wrapper.end.date')}
                  oneTap
                  value={endDate}
                  onChange={setEndDate}
                />
              </InputGroup>
            </div>
          </div>
        </div>
        <div className="report-category submit-section">
          <span>
            <input
              type="checkbox"
              id="newReportCheck"
              value={t('create.report.checkbox')}
              onChange={e => checkboxStatus(e)}
            />
            <label htmlFor="newReportCheck">{t('create.report.checkbox')}</label>
          </span>
          <Button
            type="button"
            label={t('create.report.button.label')}
            handleClick={e => handleCreateReportbtnClick(e)}
            className="btn-report"
          />
        </div>

        {/* Field Validation Modal */}
        <ModalWindow
          className="fqa-modal--createerror"
          isOpen={showFilterErrorModal}
          onRequestClose={handleOnCloseErrorModal}
          heading={t('create.report.error.modal.heading')}
        >
          <p className="fqa-model-createerror--message">
            {t('create.report.error.modal.instruction1')}
          </p>
          <ul>
            <li>{t('create.report.error.modal.rule1')}</li>
            {/* <li>{t('create.report.error.modal.rule2')}</li> */}
            <li>{t('create.report.error.modal.rule3')}</li>
            {/* <li>{t('create.report.error.modal.rule4')}</li> */}
            <li>{t('create.report.error.modal.rule5')}</li>
          </ul>
          <p className="fqa-model-createerror--message">
            {t('create.report.error.modal.instruction2')}
          </p>
        </ModalWindow>

        {/* Success Modal for new report showFilterSuccessModal */}
        <ModalWindow
          className="fqa-modal--success"
          isOpen={showFilterSuccessModal}
          onRequestClose={handleOnCloseSuccessModal}
          heading={t('create.report.success.heading')}
        >
          <div className="fqa-modal-success--header">
            <p className="fqa-modal-success--subheading">{t('create.report.success.subheading')}</p>
            <p className="fqa-model-success--reportid">{reportId} </p>
          </div>
          <div className="fqa-modal-success--body">
            <h3 className="fqa-model-success--bodyheading">
              {t('create.report.success.body.heading')}
            </h3>
            <h4 className="fqa-model-success--message">
              {t('create.report.success.body.subheading')}
            </h4>

            <div className="rules">
              <div className="options">
                <span className="veiw">
                  <i className="eva eva-alert-circle-outline"></i>
                  <span>{t('create.report.show.answer.option.options1.type')}</span>
                </span>
                <p className="fqa-model-success--message">
                  {t('create.report.show.answer.option.options1.desc')}
                </p>
              </div>
              <div className="options">
                <span className="veiw">
                  <i className="eva eva-checkmark-circle-2-outline"></i>
                  <span>{t('create.report.show.answer.option.options2.type')}</span>
                </span>
                <p className="fqa-model-success--message">
                  {t('create.report.show.answer.option.options2.desc')}
                </p>
              </div>
              <div className="options">
                <span className="in-progress">
                  <i className="eva eva-clock-outline"></i>
                  <span>{t('create.report.show.answer.option.options3.type')}</span>
                </span>
                <p className="fqa-model-success--message">
                  {t('create.report.show.answer.option.options3.desc')}
                </p>
              </div>
              <div className="options">
                <span className="ready">
                  <i className="eva eva-bell-outline"></i>
                  <span>{t('create.report.show.answer.option.options4.type')}</span>
                </span>
                <p className="fqa-model-success--message">
                  {t('create.report.show.answer.option.options4.desc')}
                </p>
              </div>
              <div className="options">
                <span className="error">
                  <i className="eva eva-alert-triangle-outline"></i>
                  <span>{t('create.report.show.answer.option.options5.type')}</span>
                </span>
                <p className="fqa-model-success--message">
                  {t('create.report.show.answer.option.options5.desc')}
                </p>
              </div>
            </div>
          </div>
        </ModalWindow>

        {/* Existing report modal  */}
        <ModalWindow
          className="fqa-modal--existing"
          isOpen={showFilterExistingReportModal}
          onRequestClose={handleOnCloseExistingReportModal}
          info={'text'}
          heading={t('existing.report.heading')}
        >
          <div className="fqa-modal-existing--body">
            <p className="fqa-modal-existing--subheading">
              {t('create.report.success.subheading')}
            </p>
            <p className="fqa-modal-existing--reportid">{reportId}</p>
            <p className="fqa-modal-existing--date">
              {t('existing.report.createdate')} {createDate}
            </p>
            <p className="fqa-modal-btn-wrapper">
              <button type="button" className="button-default" onClick={e => handleGoToReport(e)}>
                {t('existing.report.button.gotoreport')}
              </button>
              <button type="button" className="link-btn" onClick={e => newReportHandler(e)}>
                {t('existing.report.button.newreport')}
              </button>
            </p>
          </div>
        </ModalWindow>

        {/* Insuffiecient data popup  */}
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showDataInsufficientModal}
          onRequestClose={handleOnCloseInsuffiecientDataModal}
          heading={t('create.report.insuffiecient.heading')}
        >
          <p className="fqa-model-showanswer--message">
            {showDataInsufficientCode.level === 'ERROR'
              ? replaceAll(t('create.report.insuffiecient.subheading'), mapObj)
              : replaceAll(t('create.report.insuffiecient.subheading.warning'), mapObj)}
          </p>

          {showDataInsufficientCode.level === 'WARNING' ||
          showDataInsufficientCode.level === 'SEVERE' ? (
            <div className="fqa-model-pa--actions">
              <ActionLink
                redirectTo={''}
                value={t('create.report.insuffiecient.proceed')}
                handleClick={triggerConfirmAction}
              />
              <Button
                className="fqa-model-pa--actions-confirm"
                label={t('create.report.insuffiecient.goBack')}
                handleClick={e => {
                  e.preventDefault();
                  setShowDataInsufficientModal(false);
                }}
              />
            </div>
          ) : (
            ''
          )}
        </ModalWindow>
      </div>
    );
}

export default ReportWrapper;
